import React from "react";
import PatientSatuSehat from "./Patient";
import { Col, Row } from "reactstrap";
import EncounterSatuSehat from "./Encounter";
import AppointmentHistory from "./Appointment";
import ConditionSatuSehat from "./Condition";
import ObservationSatuSehat from "./Observation";
import ProcedureSatuSehat from "./Procedure";

export default function HompageSatuSehat({
    getData,
    getIdPatientSSP,
    getDataAppointmentPatient,
    getProvince,
    getCity,
    getRegency,
    getDistrict,
    getEncounter,
    getNewEncounter,
    getDataNewAppointmentPatient,
    getNewPatient,
    getCondition,
    getObservation,
    getProcedure
}) {
    return (
        <>
            <div style={{ display: 'block', height: '100%', overflowY: 'auto', overflowX: 'auto', padding: "10px" }}>
                <div className="container mt-2">
                    <div className="columns">
                        <div className="column is-4">
                            {/* Patient Start */}
                            <PatientSatuSehat
                                getData={getData}
                                getIdPatientSSP={getIdPatientSSP}
                                getDataAppointmentPatient={getDataAppointmentPatient}
                                getProvince={getProvince}
                                getCity={getCity}
                                getRegency={getRegency}
                                getDistrict={getDistrict}
                            />
                            {/* Patient Finish */}
                        </div>
                        <div className="column is-8">
                            <Row className="g-1">
                                <Col md={12}>
                                    {/* Appointment Start */}
                                    <AppointmentHistory
                                        getDataAppointmentPatient={getDataAppointmentPatient}
                                    />
                                    {/* Appointment Finish */}
                                </Col>
                                <Col md={12}>
                                    <EncounterSatuSehat
                                        getEncounter={getEncounter}
                                        getNewPatient={getNewPatient}
                                        getNewEncounter={getNewEncounter}
                                        getDataNewAppointmentPatient={getDataNewAppointmentPatient}
                                        getCondition={getCondition}
                                    />
                                </Col>
                                {/* <Col md={12}>
                                    <ConditionSatuSehat
                                        getCondition={getCondition}
                                    />
                                </Col>
                                <Col md={12}>
                                    <ObservationSatuSehat
                                        getObservation={getObservation}
                                    />
                                </Col>
                                <Col md={12}>
                                    <ProcedureSatuSehat
                                        getProcedure={getProcedure}
                                    />
                                </Col> */}
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


